/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Dropdown Icon component.
 */
export const MaterialDropdownIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M14 7L9 12.0104L14 17.0209L14 7Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialDropdownIcon;
